var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24pt",
    height: "24pt",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 12 0 C 5.375 0 0 5.371094 0 12 C 0 18.625 5.375 24 12 24 C 18.628906 24 24 18.625 24 12 C 24 5.371094 18.628906 0 12 0 M 12 0.960938 C 18.085938 0.960938 23.039063 5.914063 23.039063 12 C 23.039063 18.085938 18.085938 23.039063 12 23.039063 C 5.914063 23.039063 0.960938 18.085938 0.960938 12 C 0.960938 5.914063 5.914063 0.960938 12 0.960938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 15 12 C 15 13.65625 13.65625 15 12 15 C 10.34375 15 9 13.65625 9 12 C 9 10.34375 10.34375 9 12 9 C 13.65625 9 15 10.34375 15 12 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 7.417969 13.421875 C 7.273438 12.972656 7.199219 12.492188 7.199219 11.996094 C 7.199219 9.71875 8.796875 7.804688 10.933594 7.316406 L 10.933594 4.070313 C 7.019531 4.589844 4 7.941406 4 11.996094 C 4 13.074219 4.210938 14.101563 4.597656 15.039063 Z M 5.667969 16.886719 C 7.128906 18.777344 9.421875 19.996094 12 19.996094 C 14.578125 19.996094 16.871094 18.777344 18.332031 16.886719 L 15.519531 15.261719 C 14.640625 16.207031 13.386719 16.796875 12 16.796875 C 10.609375 16.796875 9.359375 16.207031 8.480469 15.261719 Z M 19.402344 15.039063 C 19.785156 14.101563 20 13.074219 20 11.996094 C 20 7.941406 16.980469 4.589844 13.066406 4.070313 L 13.066406 7.316406 C 15.203125 7.804688 16.800781 9.71875 16.800781 11.996094 C 16.800781 12.46875 16.730469 12.925781 16.605469 13.355469 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.a4e86a63a286c83b308db17e4f24612b.svg";
export { ForwardRef as ReactComponent };